
import { Investor, Contact } from "@/types/investor";
import { supabase } from "@/integrations/supabase/client";

/**
 * Database-only approach
 */
export const loadLocalProcessingProgress = () => {
  console.warn("loadLocalProcessingProgress should not be used - use database storage instead");
  return { 
    investors: [] as Investor[], 
    contacts: [] as Contact[], 
    processedIds: new Set<string>() 
  };
};

/**
 * Clear all investor data from Supabase 
 * @param userId Optional user ID for clearing Supabase data
 */
export const clearAllInvestorData = async (userId?: string) => {
  // No localStorage references
  console.log("Clearing investor data");
  
  // If user ID is provided, also clear data from Supabase
  if (userId) {
    try {
      // Delete investor data
      await supabase
        .from('investor_data')
        .delete()
        .eq('user_id', userId);
      
      console.log("All investor data cleared from Supabase");
    } catch (error) {
      console.error("Failed to clear data from Supabase:", error);
    }
  }
  
  return true;
};
